/**
 * gb-mega-header.js
 * Verhalten für gb-mega-header.liquid (golfballs.at Mega-Menü-Header)
 *
 * - Desktop: Hover (oder Tastatur-Fokus) auf einen Nav-Punkt öffnet sein
 *   Mega-Menü. Der Name selbst ist ein normaler Link (Klick navigiert zur
 *   hinterlegten Kategorie-Seite). Maus verlassen / Escape / Klick
 *   außerhalb schließt das Menü wieder.
 * - Mobile: Burger öffnet die Drawer-Navigation; jede Hauptkategorie
 *   ist ein Accordion-Panel.
 */
(function () {
  document.querySelectorAll('gb-mega-header').forEach(function (header) {
    var navItems = header.querySelectorAll('[data-nav-item]');
    var CLOSE_DELAY = 200;

    function closeAll() {
      navItems.forEach(function (i) {
        i.classList.remove('is-open');
        var l = i.querySelector('.gb-nav-link');
        if (l) l.setAttribute('aria-expanded', 'false');
      });
    }

    function openItem(item) {
      navItems.forEach(function (i) {
        if (i !== item) {
          i.classList.remove('is-open');
          var l = i.querySelector('.gb-nav-link');
          if (l) l.setAttribute('aria-expanded', 'false');
        }
      });
      item.classList.add('is-open');
      var link = item.querySelector('.gb-nav-link');
      if (link) link.setAttribute('aria-expanded', 'true');
    }

    // --- Desktop Mega-Menü: Hover + Tastatur-Fokus ---
    navItems.forEach(function (item) {
      var link = item.querySelector('.gb-nav-link');
      if (!link) return;
      var closeTimer = null;

      function scheduleClose() {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
          item.classList.remove('is-open');
          link.setAttribute('aria-expanded', 'false');
        }, CLOSE_DELAY);
      }
      function openNow() {
        clearTimeout(closeTimer);
        openItem(item);
      }

      item.addEventListener('mouseenter', openNow);
      item.addEventListener('mouseleave', scheduleClose);
      item.addEventListener('focusin', openNow);
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) scheduleClose();
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('gb-mega-header')) closeAll();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });

    // --- Desktop-Suche: erster Klick öffnet nur das Feld, zweiter Klick (mit Text) sucht wirklich ---
    header.querySelectorAll('.gb-nav-search').forEach(function (form) {
      var input = form.querySelector('.gb-nav-search__input');
      var toggle = form.querySelector('.gb-nav-search__toggle');
      if (!input || !toggle) return;

      toggle.addEventListener('click', function () {
        if (!form.classList.contains('is-active')) {
          form.classList.add('is-active');
          input.focus();
        } else if (input.value.trim() !== '') {
          form.requestSubmit ? form.requestSubmit() : form.submit();
        } else {
          input.focus();
        }
      });

      document.addEventListener('click', function (e) {
        if (!form.contains(e.target) && input.value.trim() === '') {
          form.classList.remove('is-active');
        }
      });
    });

    // --- Alle Suchformulare (Desktop-Icon + Mobile-Suchleisten): nie mit leerem Feld navigieren ---
    header.querySelectorAll('.gb-nav-search, .gb-mobile-searchbar').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var q = form.querySelector('input[type="search"]');
        if (q && q.value.trim() === '') e.preventDefault();
      });
    });
    // --- Mobile Drawer ---
    var burger = header.querySelector('.gb-burger');
    var drawer = header.querySelector('.gb-mobile');
    var closeBtn = header.querySelector('.gb-mobile__close');

    function openDrawer() {
      if (!drawer) return;
      drawer.setAttribute('data-open', 'true');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.setAttribute('data-open', 'false');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    if (burger) burger.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (drawer) {
      drawer.addEventListener('click', function (e) {
        if (e.target === drawer) closeDrawer();
      });
    }

    // --- Mobile Accordion ---
    header.querySelectorAll('.gb-mobile__item').forEach(function (item) {
      var toggle = item.querySelector('.gb-mobile__toggle');
      var panel = item.querySelector('.gb-mobile__panel');
      if (!toggle || !panel) return;

      toggle.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        header.querySelectorAll('.gb-mobile__item').forEach(function (i) {
          i.classList.remove('is-open');
          var t = i.querySelector('.gb-mobile__toggle');
          var p = i.querySelector('.gb-mobile__panel');
          if (t) t.setAttribute('aria-expanded', 'false');
          if (p) p.hidden = true;
        });

        if (!isOpen) {
          item.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
          panel.hidden = false;
        }
      });
    });
  });
})();